export default "__VITE_ASSET__223a8d50__"